import { render, staticRenderFns } from "./FeatureApp.vue?vue&type=template&id=20e12877&"
import script from "./FeatureApp.vue?vue&type=script&lang=js&"
export * from "./FeatureApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports